import { Dimensions, Platform, StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 16,
    paddingTop: 16,
  },
  scrollViewContainerStyle: withTray => ({
    paddingVertical: 16,
    paddingBottom: withTray ? 110 : 30,
  }),
  usageValuesView: {
    paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 20
  },
  headerTitle: theme => ({
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: 32,
    color: theme.colors.headerColor,
    marginBottom: 10,
  }),
  headerSubTitle: theme => ({
    fontSize: 16,
    color: theme.colors.subtitle,
    marginRight: 8,
    lineHeight: 20,
  }),
  errorIconStyle: { marginTop: 55.8 },
  usageItemsContainerStyle: {
    marginTop: 13,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 8.8
  },
  errorIconStyle: {
    marginTop: 55.8
  },
  cardWrapper: (isWeb) => (isWeb ? {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    paddingBottom: 50
  } : {})
});
